module.exports = __webpack_public_path__ + "img/发布询价@2x.55d44568.png";